import axios from 'axios'
import store from '../../store'
import { isLoading, showAlert } from '../../redux/actions/actions'
import { checkGetResult } from '../../utils/utils'

export const getOptions = (config, headers, defaultHeaders = true) => {
  const options = {
    headers: {
      'content-type': 'application/json'
    },
    ...config,
  }

  if (headers) {
    const keys = Object.keys(headers)
    keys.forEach((key) => (options.headers[key] = headers[key]))
  }

  if (defaultHeaders) {
    return options
  } else if (!defaultHeaders && !!Object.keys(headers)?.length) {
    return {
      headers,
    }
  }

  return {}
}

const resolvePromise = (response, loading, responseThen, message, errorCallback, codeException) => {
  if (loading) {
    store.dispatch(isLoading(false))
  }

  if (response.data?.resultado?.codigo && !checkGetResult(response.data)) {
    if (errorCallback) {
      errorCallback(response)
    }

    if ((!codeException && !!message) || (!!codeException && response.data.resultado.codigo !== codeException)) {
      store.dispatch(showAlert(true, false, response.data.resultado.codigo?.toString()))
    }

    return
  }

  if (responseThen) {
    responseThen(response)
  }
}

export const rejectPromise = (error, loading, responseCatch, message) => {
  if (loading) {
    store.dispatch(isLoading(false))
  }

  if (message) {
    store.dispatch(showAlert(true, false, undefined))
  }

  if (responseCatch) {
    responseCatch(error.response)
  }
}

export const get = (
  url,
  config,
  loading,
  responseThen,
  responseCatch,
  headers = {},
  message = true,
  errorCallback,
  codeException,
  defaultHeaders,
  skipTenantHeader = false,
) => {
  if (loading) {
    store.dispatch(isLoading(true))
  }

  axios
    .get(url, getOptions(config, headers, defaultHeaders, skipTenantHeader))
    .then((response) => resolvePromise(response, loading, responseThen, message, errorCallback, codeException))
    .catch((error) => {
      if (!axios.isCancel(error)) {
        return rejectPromise(error, loading, responseCatch, message)
      }
    })
}

export const post = (
  url,
  data,
  config,
  loading,
  responseThen = undefined,
  responseCatch = undefined,
  headers,
  message = true,
  errorCallback,
  defaultHeaders = true,
) => {
  if (loading) {
    store.dispatch(isLoading(true))
  }

  axios
    .post(url, data, getOptions(config, headers, defaultHeaders))
    .then((response) => resolvePromise(response, loading, responseThen, message, errorCallback))
    .catch((error) => rejectPromise(error, loading, responseCatch, message))
}

export const buildUrl = (url, variables) =>
  url.replace(/:(\w+)/g, (match, p1) => (p1 in variables ? variables[p1] : match))
